export const faqList = [
  {
    id: 1,
    question: '俄罗斯妈妈的育儿理念与中国妈妈有什么不同？',
    answer: '俄罗斯妈妈普遍更注重孩子的独立性和抗寒能力培养。从婴儿时期就开始冷水浴、户外午睡等耐寒训练，同时非常重视艺术和体育教育。与许多中国妈妈相比，俄罗斯妈妈在"精养"方面相对放松，更倾向于让孩子在大自然中自由探索。',
  },
  {
    id: 2,
    question: '俄罗斯家庭通常是多代同堂吗？',
    answer: '是的，多代同堂在俄罗斯非常普遍。祖父母（尤其是祖母"巴布什卡"）在家庭中扮演着极其重要的角色，往往承担大量的育儿工作。许多俄罗斯年轻家庭会选择与父母同住或住在附近，形成了紧密的家庭支持网络。',
  },
  {
    id: 3,
    question: '俄罗斯妈妈如何处理工作与家庭的平衡？',
    answer: '俄罗斯的产假政策相当慷慨——母亲可以享受长达3年的育儿假，其中前1.5年为带薪假期。这使得俄罗斯妈妈在孩子幼年阶段能够全身心投入育儿。重返职场后，祖父母的帮助加上灵活的托育体系，使得工作家庭平衡相对可行。',
  },
  {
    id: 4,
    question: '俄罗斯母亲节是什么时候？有哪些习俗？',
    answer: '俄罗斯的母亲节定在每年11月的最后一个星期天。这一天，孩子们会为母亲准备手写贺卡、鲜花（尤其是康乃馨）和自制礼物。学校会组织相关主题活动，家庭成员会聚在一起共进节日晚餐，向母亲表达感恩之情。',
  },
  {
    id: 5,
    question: '俄罗斯传统的育儿方式有哪些独特之处？',
    answer: '俄罗斯育儿有几个鲜明特点：1) "耐寒教育"——即使在零下二三十度的冬天，也会带孩子出门活动；2) 重视阅读——俄罗斯家庭的藏书量普遍很大，亲子阅读是日常；3) 艺术启蒙早——音乐、绘画、芭蕾等艺术教育从幼儿时期就开始；4) 饮食传统——自制酸奶、罗宋汤、黑面包等传统食物是日常必备。',
  },
  {
    id: 6,
    question: '俄罗斯的教育体系对妈妈有什么要求？',
    answer: '俄罗斯实行11年制义务教育，学校对家长的参与度要求较高。俄罗斯妈妈通常非常重视孩子的学习成绩，同时也会积极参与学校组织的各类活动。此外，课外兴趣班在俄罗斯非常普及，妈妈们往往需要在接送和陪伴方面投入大量时间。',
  },
  {
    id: 7,
    question: '如何在跨文化家庭中融合俄罗斯和中国的育儿方式？',
    answer: '跨文化家庭可以取其精华：借鉴俄罗斯的独立性培养和自然教育理念，同时保留中国家庭重视学业和孝道文化的传统。关键是夫妻双方要保持开放沟通，尊重彼此文化中的育儿智慧，找到适合自己家庭的平衡点。许多跨文化家庭发现，这种融合反而让孩子获得了更丰富的成长体验。',
  },
];